import useCurrentEventInfo from '@contexts/useCurrentEventInfo';
import { useFollowUser, useGetFollowing } from '@queries/follows';
import { useGetRoom } from '@queries/rooms';
import { useAuthStore } from '@sunrise-ui/primitives';
import { useEffect } from 'react';

export default function useFollowHost() {
  const { currentRoomId } = useCurrentEventInfo();
  const { currentUserId } = useAuthStore();
  const { data: room } = useGetRoom(currentRoomId);
  const { data: following } = useGetFollowing();
  const { mutate: followUser } = useFollowUser({ silenceErrors: true });

  const hostId = room?.user_id;
  const isFollowingUser = Boolean(
    following?.find((entity) => entity.entity_id === hostId),
  );

  useEffect(() => {
    if (following && hostId && !isFollowingUser && hostId !== currentUserId) {
      followUser(hostId);
    }
  }, [following, hostId, isFollowingUser, followUser]);
}
